import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxProfilAcquereur extends Component {

    static defaultProps = {
        label: "Profil acquéreur",
        placeholder: "Profil acquéreur",
    };

    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const options = [
                { key: "Investisseur", text: "Investisseur" },
                { key: "Occupant", text: "Occupant" }
            ];
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
        />;

    };

};